const routes = [
  {
    path: '/',
    name: 'home',
    meta: { keepAlive: true, showTabbar: true },
    component: () => import('../views/home')
  },
  {
    path: '/jump',
    name: 'jump',
    meta: { keepAlive: true, title: '跳转中' },
    component: () => import('../views/jump')
  },
  {
    path: '/find',
    name: 'find',
    meta: { title: '发现', keepAlive: true },
    component: () => import('../views/find/find')
  },
  {
    path: '/app',
    name: 'app',
    component: () => import('../views/home/app')
  },
  {
    path: '/live',
    name: 'live',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '/live',
        meta: { title: '直播', keepAlive: true },
        component: () => import('../views/live/newIndex')
      },
      {
        path: '/live/live/:id',
        name: 'liveLive',
        meta: { title: '直播回放' },
        component: () => import('../views/live/newlive')
      },
      {
        path: '/live/:id',
        name: 'liveDetails',
        meta: { title: '直播' },
        component: () => import('../views/live/details')
      }
    ]
  },
  //知识超市
  {
    path: '/course',
    name: 'course',
    meta: { title: '课程' },
    component: () => import('../views/course/index.vue')
  },
  // {
  //   path: '/course',
  //   name: 'course',
  //   meta: { keepAlive: true },
  //   component: () => import('../views/course/course/index.vue')
  // },
  {
    path: '/micro',
    name: 'micro',
    meta: { keepAlive: true },
    component: () => import('../views/course/micro/index.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: { title: '登录' },
    component: () => import('../views/login')
  },
  {
    path: '/microCourse/detail/:id',
    name: 'microCourseDetail',
    component: () => import('../views/course/micro-course')
  },
  {
    path: '/microCourse/pay/:id',
    name: 'microCoursePay',
    component: () => import('../views/course/micro-course/Pay.vue')
  },
  {
    path: '/study',
    name: 'study',
    meta: { title: '我的已购', showTabbar: true, keepAlive: true },
    component: () => import('../views/study')
  },
  {
    path: '/giftOrder',
    name: 'giftOrder',
    meta: { title: '赠送订单' },
    component: () => import('../views/study/giftOrder.vue')
  },
  {
    path: '/my',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '/my',
        redirect: '/my/index'
      },
      {
        path: '/my/index',
        name: 'my',
        meta: { title: '我的', showTabbar: true },
        component: () => import('../views/my/index.vue')
      },
      {
        path: '/my/coin',
        name: 'coin',
        meta: { title: '我的学习币' },
        component: () => import('../views/my/coin')
      },
      {
        path: '/my/invest',
        name: 'invest',
        meta: { title: '充值' },
        component: () => import('../views/my/invest')
      },
      {
        path: '/my/wallet',
        name: 'wallet',
        meta: { title: '我的钱包' },
        component: () => import('../views/my/wallet')
      },
      {
        path: '/my/wallet/log',
        name: 'walletLog',
        meta: { title: '钱包明细' },
        component: () => import('../views/my/wallet/log.vue')
      },
      {
        path: '/my/studymarks',
        name: 'studymarks',
        meta: { title: '最近学习' },
        component: () => import('../views/my/studymarks')
      },
      {
        path: '/my/notes',
        name: 'notes',
        meta: { title: '我的笔记' },
        component: () => import('../views/my/notes')
      },
      {
        path: '/my/personal',
        name: 'personal',
        meta: { title: '编辑资料' },
        component: () => import('../views/my/personal')
      },
      {
        path: '/my/setting',
        name: 'setting',
        meta: { title: '设置' },
        component: () => import('../views/my/setting')
      },
      {
        path: '/my/security',
        name: 'security',
        meta: { title: '账号与安全' },
        component: () => import('../views/my/security')
      },
      {
        path: '/my/cancellation',
        name: 'cancellation',
        meta: { title: '注销账号' },
        component: () => import('../views/my/cancellation')
      },
      {
        path: '/my/aboutus',
        name: 'setting',
        meta: { title: '关于我们' },
        component: () => import('../views/my/setting/aboutus')
      },
      {
        path: '/my/studyRecord',
        name: 'studyRecord',
        meta: { title: '学习记录' },
        component: () => import('../views/my/studyRecord')
      },
      {
        path: '/my/guide',
        name: 'guide',
        meta: { title: '小慧君' },
        component: () => import('../views/my/guide')
      },
      {
        path: '/my/help',
        name: 'help',
        meta: { title: '帮助中心' },
        component: () => import('../views/my/help')
      },
      {
        path: '/my/collect',
        name: 'myCollect',
        meta: { title: '我的收藏' },
        component: () => import('../views/my/collect')
      },
      {
        path: '/my/help/details',
        name: 'helpDetails',
        meta: { title: '帮助中心' },
        component: () => import('../views/my/help/details.vue')
      },
      {
        path: '/my/follow',
        name: 'myFollow',
        meta: { title: '关注' },
        component: () => import('../views/my/follow')
      }
    ]
  },
  {
    path: '/register',
    component: () => import('../views/register')
  },
  {
    path: '/courseDetail',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '/courseDetail/courseGift',
        name: 'courseGift',
        meta: { title: '领取礼物' },
        component: () => import('../views/course-detail/courseGift')
      },
      {
        path: '/courseDetail/successBuy',
        name: 'courseDetailSucBuy', //query type:1=>购买成功 type:2=>激活成功
        component: () => import('../views/course-detail/successBuy')
      },
      {
        path: '/courseDetail/detail',
        name: 'courseDetailDetail',
        component: () => import('../views/course-detail/detail')
      },
      {
        path: '/courseDetail/:courseId',
        name: 'courseDetail',
        component: () => import('../views/course-detail')
      }
    ]
  },
  {
    path: '/comment',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '/comment',
        redirect: '/comment/commentList/:courseId'
      },
      {
        path: '/comment/commentList/:courseId',
        name: 'commentList',
        meta: { title: '全部评论' },
        component: () => import('../views/comment/commentList.vue')
      },
      {
        path: '/comment/publish/:courseId',
        name: 'commentPublish',
        meta: { title: '发布评论' },
        component: () => import('../views/comment/publish.vue')
      }
    ]
  },
  {
    path: '/famous',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '/famous',
        redirect: '/famous/famousDetail/:courseId'
      },
      {
        path: '/famous/detail/:courseId',
        name: 'famousDetail',
        meta: { title: '名门望族' },
        component: () => import('../views/famous/detail.vue')
      },
      //名门望族单节分享
      {
        path: '/chapterShare/:chapterId',
        name: 'famousChapterShare1',
        component: () => import('../views/chapter-share')
      },
      {
        path: '/famous/chapterShare/:chapterId',
        name: 'famousChapterShare2',
        component: () => import('../views/chapter-share')
      },
      {
        path: '/famous/draft/:chapterId',
        name: 'famousDraft',
        meta: { title: '名门望族' },
        component: () => import('../views/famous/draft.vue')
      }
    ]
  },
  {
    path: '/rose',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '/rose/index',
        meta: { title: '学习打卡' },
        component: () => import('../views/rose/index.vue')
      },
      {
        path: '/rose/redBag',
        name: 'roseRedBag',
        component: () => import('../views/rose/redBag.vue')
      },
      {
        path: '/rose/note/:noteId',
        name: 'roseNote',
        meta: { title: '笔记详情' },
        // query: 日期=>date
        component: () => import('../views/rose/note.vue')
      }
    ]
  },
  {
    path: '/explain',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '/explain',
        redirect: '/explain/list/:courseId'
      },
      {
        path: '/explain/index',
        meta: { title: '红兰解读.打卡游戏' },
        component: () => import('../views/explain/index.vue')
      },
      {
        path: '/explain/list/:courseId',
        name: 'explainList',
        meta: { title: '红兰解读' },
        component: () => import('../views/explain/list.vue')
      },
      {
        path: '/explain/chapter/:chapterId',
        name: 'explainChapter',
        // meta: { title: '红兰解读' },  //红兰解读章节播放页
        component: () => import('../views/explain/chapter.vue')
      },
      // {
      //   path: '/explain/group',
      //   name: 'explainGroup',
      //   meta: { title: '扫码报名' },
      //   component: () => import('../views/explain/group.vue')
      // },
      {
        path: '/explain/group',
        name: 'explainGroup',
        meta: { title: '扫码添加' },
        component: () => import('../views/explain/addCode.vue')
      },
      {
        path: '/explain/comments/:courseId',
        name: 'explainComments',
        meta: { title: '全部评论' },
        component: () => import('../views/explain/comments.vue')
      },
      {
        path: '/explain/publish',
        name: 'explainPublish',
        meta: { title: '打卡笔记' },
        component: () => import('../views/explain/publish.vue')
      },
      {
        path: '/explain/note/:noteId', //红兰笔记分享页
        name: 'explainNote', //query: chapterId
        meta: { title: '红兰解读' },
        component: () => import('../views/explain/note.vue')
      },
      {
        path: '/explain/redBag',
        name: 'explainRedBag',
        meta: { title: '红兰解读' },
        component: () => import('../views/explain/redBag.vue')
      },
      {
        path: '/explain/clockSuccess/:noteId', //打卡成功页，APP
        meta: { title: '打卡成功' }, //query: chapterId
        component: () => import('../views/explain/clockSuccess.vue')
      }
    ]
  },
  {
    path: '/dailySayShare/:dailySayId',
    name: 'dailySayShare',
    meta: { title: '每日一说' },
    component: () => import('../views/dailySay-share')
  },
  {
    path: '/hotCourses',
    name: 'hotCourses',
    meta: { title: '课程榜单' },
    component: () => import('../views/hotCourses')
  },
  {
    path: '/freeCourseDetail/:courseId',
    name: 'freeCourseDetail',
    meta: { title: '免费体验' },
    component: () => import('../views/free-course-detail')
  },
  {
    path: '/article/:id',
    name: 'article',
    component: () => import('../views/article')
  },
  {
    path: '/payment/:courseId',
    name: 'payment',
    component: () => import('../views/payment')
  },
  {
    path: '/ranking', //排行榜
    component: { render: h => h('router-view') },
    children: [
      {
        path: '/ranking/:type', //红兰打卡和玫瑰园打卡排行榜
        name: 'ranking',
        meta: { title: '玫瑰园计划打卡排行榜' },
        component: () => import('../views/ranking')
      }
    ]
  },
  {
    path: '/shortvideo/:id',
    name: 'shortVideo',
    component: () => import('../views/short-video')
  },
  {
    path: '/search',
    name: 'search',
    meta: { keepAlive: true },
    component: () => import('../views/search')
  },
  {
    path: '/vip',
    name: 'vip',
    component: () => import('../views/vip')
  },
  {
    path: '/vip/vipLoveNature',
    name: 'vipLoveNature',
    component: () => import('../views/vip/vipLoveNature')
  },
  {
    path: '/vip/giftBag',
    name: 'giftBag',
    meta: { title: '体验课' },
    component: () => import('../views/vip/giftBag')
  },
  {
    path: '/vip/giftCard/:id', //courseId
    name: 'vipGiftCard',
    component: () => import('../views/vip/giftCard/index')
  },
  {
    path: '/vip/give',
    name: 'vipGive',
    meta: { title: '赠送礼品包' },
    component: () => import('../views/vip/give')
  },
  {
    path: '/vip/gift',
    name: 'vipGift',
    meta: { title: '家慧库' },
    component: () => import('../views/vip/gift')
  },
  {
    path: '/vip/exchange',
    name: 'vipExchange',
    meta: { title: '会员激活码' },
    component: () => import('../views/vip/exchange')
  },
  {
    path: '/free',
    name: 'free',
    meta: { title: '免费区' },
    component: () => import('../views/free')
  },
  {
    path: '/charity', //慈善
    name: 'charity',
    meta: { title: '慈善' },
    component: () => import('../views/charity')
  },
  {
    path: '/camp',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '/camp',
        redirect: '/camp/index'
      },
      {
        path: '/camp/index',
        name: 'camp',
        meta: { title: '特训营', keepAlive: true },
        component: () => import('../views/camp/index.vue')
      },
      {
        path: '/camp/campLive',
        name: 'campLive',
        meta: { title: '直播回放' },
        component: () => import('../views/camp/campLive.vue')
      },
      {
        path: '/camp/campDetail', //query(id:特训营Id)
        name: 'campDetail',
        meta: { title: '特训营' },
        component: () => import('../views/camp/campDetail.vue')
      },
      {
        path: '/camp/campReceive', //query(id:特训营Id,giftCode: 兑换码)
        name: 'campReceive',
        component: () => import('../views/camp/campReceive.vue')
      },
      {
        path: '/camp/campSuccess',
        name: 'campSuccess',
        component: () => import('../views/camp/campSuccess.vue')
      }
    ]
  },
  {
    path: '/personalDetail', //公益
    name: 'personalDetail',
    meta: { title: '人才培养' },
    component: () => import('../views/personal/personalDetail.vue')
  },
  {
    path: '/personnel/', //公益
    name: 'personnel',
    meta: { title: '人才培养' },
    component: () => import('../views/personnel')
  },
  {
    path: '/publicGood', //公益
    name: 'publicGood',
    meta: { title: '公益' },
    component: () => import('../views/public-good')
  },
  {
    path: '/personal',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '/personal/firstPage',
        name: 'firstPage',
        meta: { title: '完善考证信息' },
        component: () => import('../views/personal/components/firstPage.vue')
      },
      {
        path: '/personal/secondPage',
        name: 'secondPage',
        meta: { title: '完善考证信息' },
        component: () => import('../views/personal/components/secondPage.vue')
      },
      {
        path: '/personal/thirdPage',
        name: 'thirdPage',
        meta: { title: '完善考证信息' },
        component: () => import('../views/personal/components/thirdPage.vue')
      },
      {
        path: '/personal/fourthPage',
        name: 'fourthPage',
        meta: { title: '完善考证信息' },
        component: () => import('../views/personal/components/fourthPage.vue')
      },
      {
        path: '/personal/fifthPage',
        name: 'fifthPage',
        meta: { title: '确认填写信息' },
        component: () => import('../views/personal/components/fifthPage.vue')
      }
    ]
  },
  // {
  //   path: '/vip/pay/:id',
  //   name: 'vipPay',
  //   meta: { title: '结算台' },
  //   component: () => import('../views/vip/Pay.vue')
  // },
  {
    path: '/personal/:id',
    name: 'personalPage',
    component: () => import('../views/personal')
  },
  {
    path: '/mentorList',
    name: 'mentorList',
    component: () => import('../views/personal/mentorList.vue')
  },
  {
    path: '/mentorHome/:userId',
    name: 'mentorHome',
    meta: { title: '导师主页' },
    component: () => import('../views/personal/mentorHome.vue')
  },
  {
    path: '/growUp', //成长通道
    component: { render: h => h('router-view') },
    children: [
      {
        path: '/growUp/presidentBecome', //分会长升级成功
        name: 'presidentBecome',
        meta: { title: '申请社区分会会长' },
        component: () => import('../views/grow-up/presidentBecome.vue')
      },
      {
        path: '/growUp/presidentCamp', //分会长特训营报名
        name: 'presidentCamp',
        meta: { title: '申请社区分会会长' },
        component: () => import('../views/grow-up/presidentCamp.vue')
      },
      {
        path: '/growUp/presidentDetail', //分会长介绍页
        name: 'presidentDetail',
        component: () => import('../views/grow-up/presidentDetail.vue')
      },
      {
        path: '/growUp/presidentTask', //中级服务师排行榜
        name: 'middleServeTask',
        meta: { title: '排行榜' },
        component: () => import('../views/grow-up/middleServeTask.vue')
      },
      {
        path: '/growUp/serveTask', //服务师排行榜
        name: 'serveTask',
        meta: { title: '排行榜' },
        component: () => import('../views/grow-up/serveTask.vue')
      },
      {
        path: '/growUp/invitation/:level', //邀请函（level=>1.分会长, 2.服务师）
        name: 'growUpInvitation',
        meta: { title: '邀请函' },
        component: () => import('../views/grow-up/invitation.vue')
      }
    ]
  },
  {
    path: '/groupSuccess',
    name: 'groupSuccess',
    component: () => import('../views/group-success')
  },
  {
    path: '/upgradeSuccess',
    name: 'upgradeSuccess',
    component: () => import('../views/group/upgrade-success')
  },
  {
    path: '/training/list',
    name: 'trainingList',
    component: () => import('../views/training/list')
  },
  {
    path: '/training/details/:id',
    name: 'trainingDetails',
    component: () => import('../views/training/details')
  },
  {
    path: '/training/apply/:id',
    name: 'trainingApply',
    component: () => import('../views/training/apply')
  },
  {
    path: '/training/records',
    name: 'trainingRecords',
    component: () => import('../views/training/records')
  },
  {
    path: '/training/sign/:kid/:aid',
    name: 'trainingSign',
    meta: { title: '线下课程签到' },
    component: () => import('../views/training/sign')
  },
  {
    path: '/training/update/:id',
    name: 'trainingUpdate',
    meta: { title: '线下课程' },
    component: () => import('../views/training/update')
  },
  {
    path: '/column',
    name: 'column',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '/column',
        redirect: '/app'
      },
      {
        path: '/column/home',
        name: 'columnHome',
        component: () => import('../views/column/home')
      },
      {
        path: '/column/family',
        name: 'family',
        meta: { title: '家慧库VIP专区', keepAlive: true },
        component: () => import('../views/column/newfamily')
      },
      {
        path: '/column/info',
        name: 'columnInfo',
        // meta: { title: '介绍' },
        component: () => import('../views/column/info')
      },
      {
        path: '/column/activity/family',
        name: 'columnInfoFamily',
        meta: { title: '课表' },
        component: () => import('../views/column/activity/family')
      },
      {
        path: '/column/activity/trial360',
        name: 'columnInfoTrial360',
        meta: { title: '360家庭成长' },
        component: () => import('../views/column/activity/trial360')
      },
      {
        path: '/column/activity/trialWind',
        name: 'columnInfotrialWind',
        meta: { title: '中国新家风' },
        component: () => import('../views/column/activity/trialWind')
      },
      {
        path: '/column/activity/trialVip',
        name: 'columnInfotrialVip',
        meta: { title: 'VIP权益' },
        component: () => import('../views/column/activity/trialVip')
      },
      {
        path: '/column/activity/roseGardenRule',
        name: 'columnInfoRoseGardenRule',
        meta: { title: '玫瑰园-打卡问题说明' },
        component: () => import('../views/column/activity/roseGardenRule')
      },
      {
        path: '/column/activity/honlanRule',
        name: 'columnInfoHonlanRule',
        meta: { title: '红兰解读-规则说明' },
        component: () => import('../views/column/activity/honlanRule')
      },
      {
        path: '/column/activity/rose',
        name: 'columnInfotrialRose',
        meta: { title: '玫瑰园' },
        component: () => import('../views/column/activity/rose')
      },
      {
        path: '/column/activity/vip',
        name: 'columnInfoVip',
        meta: { title: '家慧库VIP' },
        component: () => import('../views/column/activity/vip')
      },
      {
        path: '/column/activity/explodeCourse', // 爆品课详情页
        name: 'explodeCourse',
        meta: { title: '限时活动' },
        component: () => import('../views/column/activity/explodeCourse')
      },
      {
        path: '/column/activity/redBag', // 玫瑰园瓜分30万
        name: 'redBag',
        meta: { title: '限时活动' },
        component: () => import('../views/column/activity/redBag')
      }
    ]
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '/agreement',
        redirect: '/app'
      },
      {
        path: '/agreement/useService',
        name: 'useService',
        component: () => import('../views/agreement/useService')
      },
      {
        path: '/agreement/privacy',
        name: 'privacy',
        component: () => import('../views/agreement/privacy')
      },
      {
        path: '/agreement/tallage',
        name: 'tallage',
        meta: { title: '税款计算方法' },
        component: () => import('../views/agreement/tallage')
      },
      {
        path: '/agreement/studyCircle',
        name: 'studyCircle',
        meta: { title: '家慧库学习圈管理规定' },
        component: () => import('../views/agreement/studyCircle')
      },
      {
        path: '/agreement/vip',
        name: 'agreementVip',
        meta: { title: '家慧库VIP会员服务规则' },
        component: () => import('../views/agreement/vip')
      },
      {
        path: '/agreement/publish',
        name: 'agreementPublish',
        meta: { title: '家慧库内容发布规则' },
        component: () => import('../views/agreement/publish')
      },
      {
        path: '/agreement/sdk',
        name: 'agreementSdk',
        meta: { title: '家慧库第三方SDK服务商列表' },
        component: () => import('../views/agreement/sdk')
      }
    ]
  },
  {
    path: '/relation',
    name: 'relation',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '/relation/identifyPosters', //识别海报
        name: 'identifyPosters',
        component: () => import('../views/relation/identifyPosters')
      },
      {
        path: '/relation/identifyPosters/:type', //第二个识别海报 type：1(和上面是一样的样式) type:2(第二种样式)
        name: 'identifyPosters',
        component: () => import('../views/relation/identifyPosters')
      }
    ]
  },
  {
    path: '/activity',
    name: 'activity',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '/activity',
        redirect: '/app'
      },
      {
        path: '/activity/20191218',
        name: '20191218',
        meta: { title: '双旦狂欢节' },
        component: () => import('../views/activity/20191218')
      },
      {
        path: '/activity/20200124',
        name: '20200124',
        meta: { title: '新春平安大赠送' },
        component: () => import('../views/activity/20200124')
      },
      {
        path: '/activity/20200201',
        name: '20200201',
        meta: { title: '分享其他页' },
        component: () => import('../views/activity/20200201')
      },
      {
        path: '/activity/20200327',
        name: '20200327',
        meta: { title: '家慧库家庭成长月' },
        component: () => import('../views/activity/20200327')
      },
      {
        path: '/activity/20200404',
        name: '20200404',
        meta: { title: '家慧库家庭成长月' },
        component: () => import('../views/activity/20200404')
      },
      {
        path: '/activity/20200417',
        name: '20200417',
        meta: { title: '慈善专栏' },
        component: () => import('../views/activity/20200417')
      },
      {
        path: '/activity/20200418',
        name: '20200418',
        meta: { title: '家园社共育' },
        component: () => import('../views/activity/20200418')
      },
      {
        path: '/activity/20200419',
        name: '20200419',
        meta: { title: '家校社共育' },
        component: () => import('../views/activity/20200419')
      },
      {
        path: '/activity/20200501',
        name: '20200501',
        meta: { title: '515新家风VIP发布会' },
        component: () => import('../views/activity/20200501')
      },
      {
        path: '/activity/20200618',
        name: '20200618',
        meta: { title: '家慧库' },
        component: () => import('../views/activity/20200618')
      },
      {
        path: '/activity/sunlight/:id',
        name: 'sunlight',
        component: () => import('../views/activity/sunlight')
      },
      {
        path: '/activity/20200619',
        name: '20200619',
        meta: { title: 'APP升级会员福利' },
        component: () => import('../views/activity/20200619')
      },
      {
        path: '/activity/20200829',
        name: '20200829',
        meta: { title: '家慧库' },
        component: () => import('../views/activity/20200829')
      },
      {
        path: '/activity/20201212',
        name: '20201212',
        meta: { title: 'VIP双12活动' },
        component: () => import('../views/activity/20201212')
      },
      {
        path: '/activity/newGiftpack',
        name: '20211101',
        meta: { title: '新人礼包' },
        component: () => import('../views/activity/newGiftpack')
      },
      {
        path: '/activity/groupCard/:id', //集团卡详情页 id：集团卡id 391638749647224832
        name: 'groupCard',
        component: () => import('../views/activity/groupCard')
      },
      {
        path: '/activity/20210130', //推广大使
        name: '20210130',
        component: () => import('../views/activity/20210130')
      },
      {
        path: '/activity/20211111', //双11活动
        name: '双11活动',
        component: () => import('../views/activity/20211111')
      },
      {
        path: '/activity/20210327', //养育方案
        name: '20210327', //query age:1 (1岁)
        component: () => import('../views/activity/20210327')
      },
      {
        path: '/activity/offlineApplet', // 线下小程序介绍页
        name: 'offlineApplet',
        component: () => import('../views/activity/offlineApplet')
      },
      {
        path: '/activity/20211112', // 线下小程序介绍页
        name: '20211112',
        component: () => import('../views/activity/20211112')
      }
    ]
  },
  {
    path: '/giftCard',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '/giftCard',
        redirect: '/giftCard/index'
      },
      {
        path: '/giftCard/index',
        name: 'giftCard',
        meta: { title: '礼品卡' },
        component: () => import('../views/giftCard/index.vue')
      },
      {
        path: '/giftCard/give',
        name: 'giftCardGive',
        meta: { title: '送礼卡' },
        component: () => import('../views/giftCard/give.vue')
      },
      {
        path: '/giftCard/acceptStatus',
        name: 'giftCardAcceptStatus',
        meta: { title: '收下礼物' },
        component: () => import('../views/giftCard/acceptStatus.vue')
      },
      {
        path: '/giftCard/accept/:id',
        name: 'giftCardAccept',
        meta: { title: '送礼卡' },
        component: () => import('../views/giftCard/accept.vue')
      }
    ]
  },
  {
    path: '/gift',
    name: 'gift',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '/gift/give/:id',
        name: 'give',
        meta: { title: '送给好友' },
        component: () => import('../views/gift/give')
      },
      {
        path: '/gift/list',
        name: 'giveList',
        meta: { title: '赠送列表' },
        component: () => import('../views/gift/list')
      },
      {
        path: '/gift/detail/:id',
        name: 'giveDetail',
        meta: { title: '赠送详情' },
        component: () => import('../views/gift/detail')
      },
      {
        path: '/gift/receive/:id',
        name: 'giveReceive',
        meta: { title: '礼物来啦' },
        component: () => import('../views/gift/receive')
      },
      {
        path: '/gift/guide',
        name: 'giveGuide',
        meta: { title: '礼物收到啦~' },
        component: () => import('../views/gift/guide')
      },
      {
        path: '/gift/exchange',
        name: 'exchange',
        meta: { title: '兑换课程' },
        component: () => import('../views/gift/exchange')
      }
      // exchange
    ]
  },
  {
    path: '/learn',
    name: 'learn',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '/learn/class/:id',
        name: 'learnClass',
        meta: { title: '班级' },
        component: () => import('../views/learn/class')
      },
      {
        path: '/learn/comments/:id',
        name: 'learnComments',
        meta: { title: '作业评论' },
        component: () => import('../views/learn/comments')
      },
      {
        path: '/learn/homework/:id',
        name: 'learnHomework',
        meta: { title: '作业详情' },
        component: () => import('../views/learn/homework')
      }
    ]
  },
  {
    path: '/life',
    name: 'life',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '/life/index', //生活列表页
        name: 'lifeIndex',
        meta: { title: '爱家', showTabbar: true, keepAlive: true },
        component: () => import('../views/life/index')
      },
      {
        path: '/life/preview', //生活预览页
        name: 'lifePreview',
        meta: { title: '爱家' },
        component: () => import('../views/life/preview')
      },
      {
        path: '/life/detail', //生活详情页
        name: 'lifeDetail',
        meta: { title: '详情' },
        component: () => import('../views/life/detail')
      }
    ]
  },
  {
    path: '/askAnswer',
    name: 'askAnswer',
    meta: { title: '问答', showTabbar: true, keepAlive: true },
    component: () => import('../views/askAnswer/index'),
    childer: [
      {
        path: '/askAnswer/index',
        name: 'askAnswerIndex',
        mata: { title: '问答' },
        component: () => import('../views/askAnswer/components/index')
      },
      {
        path: '/askAnswer/MyQuiz',
        name: 'askAnswerMyQuiz',
        mata: { title: '我的提问' },
        component: () => import('../views/askAnswer/components/MyQuiz')
      },
      {
        path: '/askAnswer/MyAnswer',
        name: 'askAnswerMyAnswer',
        mata: { title: '我的回答' },
        component: () => import('../views/askAnswer/components/MyAnswer')
      }
    ]
  },
  {
    path: '/askAnswer/details',
    name: 'askAnswerDetails',
    meta: { title: '问答详情' },
    component: () => import('../views/askAnswer/details')
  },
  {
    path: '/askAnswer/tagSearch',
    name: 'askAnswerTagSearch',
    meta: { title: '标签搜索' },
    component: () => import('../views/askAnswer/tagSearch')
  },
  {
    path: '/popularize',
    name: 'popularize',
    meta: { title: '推广大使' },
    component: () => import('../views/popularize/index')
  },
  {
    path: '/popularize/ambassador',
    name: 'popularizeAmbassador',
    meta: { title: '推广大使信息' },
    component: () => import('../views/popularize/ambassador')
  },
  {
    path: '/popularize/application',
    name: 'popularizeApplication',
    meta: { title: '推广大使' },
    component: () => import('../views/popularize/application')
  },
  {
    path: '/popularize/pendreview',
    name: 'popularizePendreview',
    meta: { title: '推广大使' },
    component: () => import('../views/popularize/pendreview')
  },
  {
    path: '/child/index',
    name: 'child',
    meta: { title: '育儿方案' },
    component: () => import('../views/child/index')
  },
  {
    path: '/child/detail',
    name: 'childDetail',
    meta: { title: '育儿方案', keepAlive: true },
    component: () => import('../views/child/detail')
  },
  // 第二个版本 育儿方案
  {
    path: '/child/indexedition',
    name: 'childindexedition',
    meta: { title: '育儿方案' },
    component: () => import('../views/child/indexedition')
  },
  {
    path: '/child/detailedition',
    name: 'childdetailedition',
    meta: { title: '育儿方案', keepAlive: true },
    component: () => import('../views/child/detailedition')
  },
  // 第三版育儿方案
  {
    path: '/child/plan',
    name: 'plan',
    meta: { title: '0~18岁孩子专区' },
    component: () => import('../views/child/plan')
  },
  {
    path: '/kingArea',
    name: 'kingArea',
    component: () => import('../views/home/kingArea')
  },
  {
    path: '/coupon',
    name: 'coupon',
    meta: { title: '优惠卷' },
    component: () => import('../views/my/coupon/coupon')
  },
  {
    path: '/chooseCoupon',
    name: 'chooseCoupon',
    meta: { title: '优惠卷' },
    component: () => import('../views/my/coupon/chooseCoupon')
  },
  {
    path: '/receiveCoupon',
    name: 'receiveCoupon',
    meta: { title: '优惠卷' },
    component: () => import('../views/my/coupon/receiveCoupon')
  },
  {
    path: '/register/app',
    name: 'registerApp',
    meta: { title: '家慧库APP' },
    component: () => import('../views/register/app')
  },
  {
    path: '/activity/20220201',
    name: '20220201',
    meta: { title: '迎新春活动', keepAlive: true },
    component: () => import('../views/activity/20220201')
  },
  {
    path: '/groupBuy/index',
    name: 'index',
    meta: { title: '拼团' },
    component: () => import('../views/group-buy/index')
  },
  {
    path: '/groupBuy/puzzlePage',
    name: 'puzzlePage',
    meta: { title: '拼团' },
    component: () => import('../views/group-buy/puzzlePage')
  },
  {
    path: '/freeCourse',
    name: 'freeCourse',
    meta: { title: '免费课程' },
    component: () => import('../views/course/freeCourse.vue')
  },
  {
    path: '/columnTwo',
    name: 'columnTwo',
    meta: { title: ' ', keepAlive: true },
    component: () => import('../views/activity/columnTwo.vue')
  },
  {
    path: '/shortVideo',
    name: 'shortVideo',
    meta: { title: ' ' },
    component: () => import('../views/activity/shortVideo.vue')
  },
  {
    path: '/servicePerson',
    name: 'servicePerson',
    meta: { title: '服务人', keepAlive: true },
    component: () => import('../views/activity/servicePerson.vue')
  },
  {
    path: '/myservice',
    name: 'myservice',
    meta: { title: '服务人' },
    component: () => import('../views/activity/myservice.vue')
  },
  {
    path: '/AllocationRequest',
    name: 'AllocationRequest',
    meta: { title: '分配申请', keepAlive: true },
    component: () => import('../views/activity/AllocationRequest.vue')
  },
  {
    path: '/serviceAgreement',
    name: 'serviceAgreement',
    meta: { title: '服务人协议' },
    component: () => import('../views/activity/serviceAgreement.vue')
  },
  {
    path: '/informationList',
    name: 'informationList',
    meta: { title: '个人信息收集清单' },
    component: () => import('../views/agreement/inforomationList.vue')
  },
  {
    path: '/annualReport',
    name: 'annualReport',
    meta: { title: '年度报告' },
    component: () => import('../views/annual-report/index.vue')
  },
  {
    path: '/annualList',
    name: 'annualList',
    meta: { title: '年度报告' },
    component: () => import('../views/annual-report/summaryList.vue')
  },
  {
    path: '/annualbill',
    name: 'annualbill',
    meta: { title: '分享预览' },
    component: () => import('../views/annual-report/playbill.vue')
  },
  {
    path: '/annualPoster',
    name: 'annualPoster',
    meta: { title: '生成海报' },
    component: () => import('../views/annual-report/GeneratePoster.vue')
  },
  {
    path: '/annualoldGreeting',
    name: 'annualoldGreeting',
    meta: { title: '年度报告' },
    component: () => import('../views/annual-report/oldGreeting.vue')
  },
  {
    path: '/shareUser',
    name: 'shareUser',
    meta: { title: '申请成为分享员' },
    component: () => import('../views/activity/shareUser.vue')
  },
  {
    path: '/2023annualReport',
    name: '2023annualReport',
    meta: { title: '2023年度报告' },
    component: () => import('../views/activity/2023annualReport.vue')
  },
  {
    path: '/familyGrowth',
    name: 'familyGrowth',
    meta: { title: '兑换幸福家庭成长卡' },
    component: () => import('../views/course/familyGrowth.vue')
  },
  {
    path: '/exchangeRecords',
    name: 'exchangeRecords',
    meta: { title: '兑换记录' },
    component: () => import('../views/course/exchangeRecords.vue')
  },
  {
    path: '/child/indexMpFl',
    name: 'childIndexMpFl',
    meta: { title: '育儿方案' },
    component: () => import('../views/child/indexMpFl')
  },
  {
    path: '/child/detailMpFl',
    name: 'childDetailMpFl',
    meta: { title: '育儿方案' },
    component: () => import('../views/child/detailMpFl')
  },
  {
    path: '/life/previewPage',
    name: 'previewPage',
    meta: { title: '' },
    component: () => import('../views/life/previewPage')
  },
  {
    path: '/life/LiveRoom',
    name: 'LiveRoom',
    meta: { title: '家慧库聊天室' },
    component: () => import('../views/life/LiveRoom')
  },
  {
    path: '/life/transferPage',
    name: 'transferPage',
    meta: { title: '家慧库聊天室' },
    component: () => import('../views/life/transferPage')
  },
  {
    path: '/studyCircle',
    name: 'index',
    meta: { title: '学习圈', keepAlive: true },
    component: () => import('../views/learning-circle/index')
  },
  {
    path: '/studyPay',
    name: 'index',
    meta: { title: '学习圈付费页面' },
    component: () => import('../views/learning-circle/studyPay')
  },
  {
    path: '/liveStream',
    name: 'liveStream',
    meta: { title: '悦直播', keepAlive: true },
    component: () => import('../views/liveStream/liveRoom')
  },
  {
    path: '/liveStream/accompany',
    name: 'liveStreamAccompany',
    meta: { title: '悦直播', showTabbar: true },
    component: () => import('../views/liveStream/components/accompany')
  },
  {
    path: '/liveStream/liveReplay',
    name: 'liveStreamReplay',
    meta: { title: '悦直播回放' },
    component: () => import('../views/liveStream/components/liveReplay')
  },
  {
    path: '/liveStream/anchorWorkbench',
    name: 'AnchorWorkbench',
    meta: { title: '主播工作台' },
    component: () => import('../views/liveStream/components/anchorWorkbench')
  },
  {
    path: '/liveStream/operationWorkbench',
    name: 'OperationWorkbench',
    meta: { title: '运营工作台' },
    component: () => import('../views/liveStream/components/operationWorkbench')
  },
  {
    path: '/liveStream/createLiveStream',
    name: 'CreateLiveStream',
    meta: { title: '创建直播' },
    component: () => import('../views/liveStream/components/createLiveStream')
  },
  {
    path: '/liveStream/operationsManage',
    meta: { title: '运营管理' },
    component: () => import('../views/liveStream/components/operationsManage')
  },
  {
    path: '/pushLessons',
    name: 'PushLessons',
    meta: { title: '推客', showTabbar: true },
    component: () => import('../views/pushLessons/index')
  },
  {
    path: '/pushLessons/campDetail',
    name: 'PushLessonsCampDetail',
    meta: { title: '特训营' },
    component: () => import('../views/pushLessons/campDetail')
  },
  {
    path: '/liangshi',
    name: 'liangshi',
    meta: { title: '良仕学院', showTabbar: false },
    component: () => import('../views/liangshi/index')
  }
]

export default routes
